import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import ProductDetailPage from "../pages/product-detail/page";
import CartPage from "../pages/cart/page";
import LoginPage from "../pages/login/page";
import RegisterPage from "../pages/register/page";
import VerifyOtpPage from "../pages/verify-otp/page";
import AuthGuard from "../components/feature/AuthGuard";
import AccountDashboard from "../pages/account/page";
import OrdersPage from "../pages/account/orders/page";
import OrderDetailPage from "../pages/account/order-detail/page";
import WishlistPage from "../pages/account/wishlist/page";
import SettingsPage from "../pages/account/settings/page";
import CheckoutPage from "../pages/checkout/page";
import CheckoutSuccessPage from "../pages/checkout-success/page";
import AdminDashboardPage from "../pages/admin/dashboard/page";
import AdminProductsPage from "../pages/admin/products/page";
import AdminOrdersPage from "../pages/admin/orders/page";
import AdminCustomersPage from "../pages/admin/customers/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/:category",
    element: <ProductsPage />,
  },
  {
    path: "/product/:slug",
    element: <ProductDetailPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/checkout/success",
    element: <CheckoutSuccessPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/verify-otp",
    element: <VerifyOtpPage />,
  },
  {
    path: "/account",
    element: (
      <AuthGuard>
        <AccountDashboard />
      </AuthGuard>
    ),
  },
  {
    path: "/account/orders",
    element: (
      <AuthGuard>
        <OrdersPage />
      </AuthGuard>
    ),
  },
  {
    path: "/account/orders/:id",
    element: (
      <AuthGuard>
        <OrderDetailPage />
      </AuthGuard>
    ),
  },
  {
    path: "/account/wishlist",
    element: (
      <AuthGuard>
        <WishlistPage />
      </AuthGuard>
    ),
  },
  {
    path: "/account/settings",
    element: (
      <AuthGuard>
        <SettingsPage />
      </AuthGuard>
    ),
  },
  // Admin
  {
    path: "/admin",
    element: <AdminDashboardPage />,
  },
  {
    path: "/admin/products",
    element: <AdminProductsPage />,
  },
  {
    path: "/admin/orders",
    element: <AdminOrdersPage />,
  },
  {
    path: "/admin/orders/:id",
    element: <AdminOrdersPage />,
  },
  {
    path: "/admin/customers",
    element: <AdminCustomersPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;